import {useEffect, useState} from 'react';
import { Button, Modal, Spinner } from 'react-bootstrap';
import FemaleIcon from '../assets/images/Overview/Mary-Policy.svg';
import MaleIcon from '../assets/images/Overview/Adam-Policy.svg';
import '../assets/css/Style.css';
import { getApiService } from '../services/ApiService';
import { GetPayLoad } from '../services/PayLoadStorage';
import Cookies from 'js-cookie';


const Coveragedependents = ({ caseData, onClose }) => {

    const Payload = GetPayLoad('PayLoad');
    const [dependentsData, setDependentsData] = useState([]);
    const caseIdentifier = caseData?.cimNum + '_' + caseData?.empNum;
    const [isLoading, setIsLoading] = useState(true);
    const [dependentsContent, setDependentsContent] = useState([]);

    const baseUrl = process.env.REACT_APP_API_BASE_URL;
    const headers = {
            "X-Hps-Client-Id": process.env.REACT_APP_API_CLIENT_ID,
            "X-Hps-Secret-Id": process.env.REACT_APP_API_SECRET_ID,
            "X-Hps-Region": Payload?.region,
            "X-Hps-Carrier": Payload?.owning_carrier
        };
    const lang = Cookies.get('lang') || 'eng';
    const siteCd = Payload?.site_cd || '';
        
    useEffect(() => {
        if(siteCd !='') {
            const page = 'dependents'; 
            const targetUrl = process.env.REACT_APP_API_CMS_CONTENT_ENDPOINT;            
            getApiService(
                baseUrl,
                targetUrl,
                {
                    page: page,
                    site_cd: siteCd,
                    lang: lang
                },
                headers
            )
            .then((response) => {
                if(response?.data && response.data.status === 'SUCCESS'){
                    const result = response.data.data;
                    setDependentsContent(result?.dependents);
                }
            })
            .catch((error) =>{
                console.log(error);
            })
        }
    }, [lang]);

    
    useEffect(() => {

        const targetUrl = process.env.REACT_APP_API_GET_DEPENDETS_ENDPOINT;
        const payload = {
            cim: Payload?.cim
        };
        
        getApiService(  baseUrl, 
                        targetUrl, 
                        payload, 
                        headers).
                        then((result) =>{
                           
                            if(result?.data?.statusCode === 200){
                                const response = result?.data?.data;
                                if(response.hasOwnProperty(caseIdentifier)){
                                     setDependentsData(response[caseIdentifier]);   
                                }
                                setIsLoading(false);
                            }
                            
                        }).catch((error) => {
                            // Handle errors here
                            console.error('API call error:', error);
                            setIsLoading(false);
                        }
                        );

    }, []);

    const relationshipMap = [ {
        "D" : dependentsContent?.dependents_modal_daughter,
        "S" : dependentsContent?.dependents_modal_son,
        "W" : dependentsContent?.dependents_modal_wife,
        "H" : dependentsContent?.dependents_modal_husband,
    }];

    return (
        <>
            <Modal.Header closeButton className={`pb-4 ${Payload?.owning_carrier === 'Q5' ? 'mobile-close-btn' : ''}`}>
                <Modal.Title className="w-100" tabindex={0}>
                    <h4 className="d-block dependent-modal-title">
                        {dependentsContent?.dependents_modal_title}
                        <span className="d-block mt-2 dependent-label">
                            {dependentsContent?.dependents_modal_plan_name}: {caseData?.planName} | {dependentsContent?.dependents_modal_case_id}: {caseData?.caseId}
                        </span>
                    </h4>
                </Modal.Title>
            </Modal.Header>
            
            <Modal.Body>
                <div className='bd-example'>
                <div className='tab-content'>
                <div className="mb-2">
                    <div className="d-flex align-items-center primary-pay rounded p-3 col-12 mb-4">
                        <div tabIndex={0} className="d-flex align-items-center flex-grow-1">
                            {Payload?.owning_carrier !== 'Q5' && (
                            <div className="rounded-circle text-center me-3">
                                <img className="dependent-avatar" src={caseData?.gender === 'F' ? FemaleIcon : MaleIcon} alt="Primary Dependent" />
                            </div>
                            )}
                            <div className="dependent-info">
                                <h4 className="dependent-name mb-1">{caseData?.displayName}</h4>
                                <div className="dependent-label">{dependentsContent?.dependents_modal_date_of_birth}: {caseData?.dateOfBirth}</div>
                                <div className="dependent-label">{dependentsContent?.dependents_modal_effective_date}: {caseData?.planEffDate}</div>
                            </div>
                        </div>
                        <div className="ms-3">
                            <button
                                className={`btn ${Payload?.owning_carrier === 'Q5' ? 'btn-account-holder' : 'btn-warning'} btn-sm rounded px-3 dependent-btn`}
                            >
                                {dependentsContent?.dependents_modal_primary}
                            </button>
                        </div>
                    </div>
                    {   
                            
                        Object.entries(dependentsData).map(([key, value], index) => (
                            <div className="d-flex align-items-center primary-pay rounded p-3 col-12 mb-4" key={index}>
                                <div tabIndex={0} className="d-flex align-items-center flex-grow-1">
                                    {Payload?.owning_carrier !== 'Q5' && (
                                    <div className="rounded-circle text-center me-3">
                                        <img className="dependent-avatar" src={value?.gender === 'F' ? FemaleIcon : MaleIcon}  alt="Adam Watson" />
                                    </div>
                                    )}
                                    <div className="dependent-info">
                                        <h4 className="dependent-name mb-1">{value?.first_name + " " +value?.last_name}</h4>
                                        <div className="dependent-label">{dependentsContent?.dependents_modal_date_of_birth}: {value?.date_of_birth}</div>
                                        <div className="dependent-label">{dependentsContent?.dependents_modal_effective_date}: {value?.dep_effective_date}</div>
                                    </div>
                                </div>
                                <div className="ms-3">
                                    <button
                                        aria-label={"relationship is"+value?.relationship_desc}
                                        className={`btn ${Payload?.owning_carrier === 'Q5' ? 'btn-account-holder' : 'btn-success'} btn-sm rounded px-3 dependent-btn`}
                                    >
                                        { value?.relationship_desc }
                                    </button>
                                </div>
                            </div>
                        ))
                    }
                    
                    <div className="d-flex gap-3 mt-4">
                        <Button
                            {...(Payload?.owning_carrier !== 'Q5' && { variant: "secondary" })}
                            className={`flex-grow-1 btn ${Payload?.owning_carrier === 'Q5' ? 'btn-outline-secondary' : 'btn-secondary'} btn-lg col-6`}
                            onClick={onClose}
                        >
                        {dependentsContent?.dependents_modal_close_btn}
                        </Button>
                    </div>
                </div>
                </div>
                </div>
            </Modal.Body>
        </>
    );
};

export default Coveragedependents;